import { c as _c } from "react/compiler-runtime";
import { LOCALE } from '@/constants/config';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useState } from 'react';
import StripeContext from './stripe.context';
const stripePromise = loadStripe(process.env.STRIPE_API_TOKEN_PUBLIC ?? '');
var StripeMode;
(function (StripeMode) {
    StripeMode["payment"] = "payment";
    StripeMode["setup"] = "setup";
    StripeMode["subscription"] = "subscription";
})(StripeMode || (StripeMode = {}));
function convertToCents(amount) {
    const [euros, cents = '00'] = amount.toFixed(2).split('.');
    return parseInt(euros, 10) * 100 + parseInt((cents + '00').slice(0, 2), 10);
}
const StripeProvider = t0 => {
    const $ = _c(12);
    const { children } = t0;
    const [stripeAmount, setStripeAmount] = useState(1);
    let t1;
    if ($[0] !== stripeAmount) {
        t1 = convertToCents(stripeAmount);
        $[0] = stripeAmount;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    const amount = t1;
    let t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [{
                src: "url(\"/fonts/Open_Sans/OpenSans-SemiBold.ttf\")",
                family: "\"Open Sans\"",
                weight: "600"
            }, {
                src: "url(\"/fonts/Open_Sans/OpenSans-Regular.ttf\")",
                family: "\"Open Sans\"",
                weight: "400"
            }];
        $[2] = t3;
    }
    else {
        t3 = $[2];
    }
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            theme: "stripe",
            variables: {
                colorPrimary: "#1aae94",
                colorText: "#333333",
                colorTextSecondary: "#666666",
                colorDanger: "#ad2216",
                fontFamily: "Open Sans, system-ui, sans-serif",
                borderRadius: "18px",
                colorTextPlaceholder: "#999999",
                fontSizeBase: "14px",
                fontWeightNormal: "600"
            },
            rules: {
                ".Tab": {
                    border: "1px solid #dddddd",
                    boxShadow: "none"
                },
                ".Input": {
                    color: "var(--colorTextSecondary)",
                    border: "1px solid #dddddd",
                    boxShadow: "none"
                }
            }
        };
        $[3] = t4;
    }
    else {
        t4 = $[3];
    }
    let t5;
    if ($[4] !== amount) {
        t5 = {
            locale: LOCALE,
            fonts: t3,
            appearance: t4,
            mode: StripeMode.payment,
            currency: "eur",
            amount
        };
        $[4] = amount;
        $[5] = t5;
    }
    else {
        t5 = $[5];
    }
    t2 = t5;
    const stripeOptions = t2;
    let t6;
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
            setStripeAmount
        };
        $[6] = t7;
    }
    else {
        t7 = $[6];
    }
    t6 = t7;
    const providerValue = t6;
    let t8;
    let t9;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = <link rel="preconnect" href="https://m.stripe.com"/>;
        t9 = <link rel="preconnect" href="https://r.stripe.com"/>;
        $[7] = t8;
        $[8] = t9;
    }
    else {
        t8 = $[7];
        t9 = $[8];
    }
    let t10;
    if ($[9] !== children || $[10] !== stripeOptions) {
        t10 = <StripeContext value={providerValue}>{t8}{t9}<Elements stripe={stripePromise} options={stripeOptions}>{children}</Elements></StripeContext>;
        $[9] = children;
        $[10] = stripeOptions;
        $[11] = t10;
    }
    else {
        t10 = $[11];
    }
    return t10;
};
export default StripeProvider;
